<template>
  <div class="content">
    <Banner :bannerImg="$store.getters.getUrl('yc_banner')"></Banner>
    <Downbtn></Downbtn>
    <Xianlu></Xianlu>
    <Games></Games>
    <HotList :popularImg="$store.getters.getUrl('ks_remen')" :iconUrl="$store.getters.getUrl('ks_remenTitle')"></HotList>
    <Foot v-if="$store.getters.getKey('closefoot')==0"></Foot>
    <Bottom :bottomImg="$store.getters.getUrl('ks_gif')" :style="{'marginTop':'40px'}"></Bottom>
    <a :href="kefu_address" class="btn" target="_blank">
      <img :src="$store.getters.getUrl('kf')" alt=""  class="kf" />
    </a>
  </div>
</template>

<script>
import Banner from "@page/landing/components/banner.vue";
import Bottom from "@page/landing/components/bottom.vue";
import HotList from "@page/landing/components/hotList.vue";


import Downbtn from "@page/landing/template/copyks/components/downbtn.vue";
import Xianlu from "@page/landing/template/copyks/components/xianlu.vue";
import Games from "@page/landing/template/newks/components/games.vue";
import Foot from "@page/landing/template/newks/components/foot.vue";
import { get } from "lodash-es";

export default {
  components: {
    Banner,
    Downbtn,
    Xianlu,
    Games,
    HotList,
    Bottom,
    Foot
  },
  computed:{
    closefoot() {
      if(this.$store.getters.getKey('closefoot')==1){
        return this.$store.getters.getKey('closefoot')
      }else{
        return 0
      }
    },
    kefu_address() {
      return get(this.$store.state, "webUrls.official_kefu_url", "");
    }
  },
};
</script>

<style lang="scss" scoped>
.content{
  background: #000;
  padding-bottom: 160px;
    .kf{
    position: fixed;
    right: 0px;
    top: 78%;
    width:120px;
    z-index: 9999;
  }
  .bottom{
    position: fixed;
    bottom: 0px;
  }
}
</style>
